import React from 'react';
import { ScrollView } from 'react-native-gesture-handler';
import { View } from 'react-native';
import { ScreenContainer } from '../../../layout/ScreenContainer';
import { LineTitle } from '../../../molecules/LineTitle';
import { MediumText } from '../../../atoms/MediumText';
import ClientLogo from '../../../atoms/ClientLogo';

export const DDRScreen = (): React.ReactElement => {
  return (
    <ScrollView>
      <ScreenContainer>
        <LineTitle title="Zai Direct Debit Request" />

        {/* Section 1: Logo and Company Details */}
        <View
          style={{
            flexDirection: 'row',
            marginBottom: 24,
            alignItems: 'flex-start',
          }}
        >
          {/* Left side: PokitPal Logo */}
          <View style={{ flex: 1, height: 110 }}>
            <ClientLogo />
          </View>

          {/* Right side: Company Details */}
          <View style={{ flex: 2, paddingLeft: 16 }}>
            <MediumText style={{ fontWeight: 'bold', marginBottom: 4 }}>
              PokitPal Pty Ltd
            </MediumText>
            <MediumText style={{ marginBottom: 2 }}>
              Level 17, International Tower 3, 300 Barangaroo Ave
            </MediumText>
            <MediumText>+61 2 8089 4054</MediumText>
          </View>
        </View>

        {/* Authorization Text */}
        <MediumText style={{ marginBottom: 16, lineHeight: 20 }}>
          You request and authorise Zai Australia Pty Ltd (Zai), User ID's
          342203 and 481561, as agent for PokitPal to arrange a debit to your
          nominated account to pay for Round-Ups provided by PokitPal.
        </MediumText>

        <MediumText style={{ marginBottom: 16, lineHeight: 20 }}>
          This debit or charge will be arranged by Zai's financial institution
          and made through the Bulk Electronic Clearing System Framework (BECS)
          from your nominated account and will be subject to the terms and
          conditions of the Direct Debit Request Service Agreement.
        </MediumText>
      </ScreenContainer>
    </ScrollView>
  );
};
